import { useState, type FormEvent } from "react";
import { Card } from "../../components/ui/Card";
import { Eyebrow } from "../../components/ui/Eyebrow";
import { CtaButton } from "../../components/ui/Button";
import { useMeasurements } from "./useMeasurements";
import { formatNumber, formatDate } from "../../lib/format";

function Field({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <label className="block">
      <span className="mb-1 block font-mono text-[9px] uppercase tracking-[0.12em] text-muted">
        {label}
      </span>
      <input
        inputMode="decimal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="—"
        className="w-full rounded-inner border border-line bg-white/[.03] px-3 py-3 text-[15px] text-text outline-none focus:border-accent"
      />
    </label>
  );
}

export function MeasurementsPage() {
  const { history, loading, addMeasurement } = useMeasurements();
  const [weight, setWeight] = useState("");
  const [waist, setWaist] = useState("");
  const [chest, setChest] = useState("");
  const [arm, setArm] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      await addMeasurement({
        weight_kg: weight ? Number(weight) : null,
        waist_cm: waist ? Number(waist) : null,
        chest_cm: chest ? Number(chest) : null,
        arm_cm: arm ? Number(arm) : null,
      });
      setWeight("");
      setWaist("");
      setChest("");
      setArm("");
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <Card>
        <Eyebrow>Registro semanal</Eyebrow>
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-3">
          <Field label="Peso (kg)" value={weight} onChange={setWeight} />
          <Field label="Cintura (cm)" value={waist} onChange={setWaist} />
          <Field label="Pecho (cm)" value={chest} onChange={setChest} />
          <Field label="Brazo (cm)" value={arm} onChange={setArm} />
          <div className="col-span-2">
            <CtaButton type="submit" disabled={saving}>
              {saving ? "Guardando…" : "Guardar medidas"}
            </CtaButton>
          </div>
        </form>
      </Card>

      <Card>
        <Eyebrow>Histórico</Eyebrow>
        {loading && <p className="text-sm text-muted">Cargando…</p>}
        {!loading && history.length === 0 && (
          <p className="text-sm text-muted">Todavía no hay medidas registradas.</p>
        )}
        {history.map((m) => (
          <div key={m.id} className="flex items-center justify-between border-t border-line py-2.5 first:border-t-0">
            <span className="font-mono text-[11px] uppercase tracking-[0.08em] text-muted">
              {formatDate(m.date)}
            </span>
            <span className="font-mono text-[12px] text-accent-bright">
              {formatNumber(m.weight_kg)} kg · C {formatNumber(m.waist_cm)} · P {formatNumber(m.chest_cm)}
            </span>
          </div>
        ))}
      </Card>
    </>
  );
}
